import React, { useState, useEffect, useRef } from 'react';
import { ANIMATION_TIMINGS } from '../constants/config';
import './IntroAnimation.css';

const IntroAnimation = ({ onComplete, skipAnimation }) => {
  const [currentPhase, setCurrentPhase] = useState('travel-big');
  const [showHomePage, setShowHomePage] = useState(false);
  const timerIdsRef = useRef([]);

  const handleClick = () => {
    // Clear all pending timers
    timerIdsRef.current.forEach(id => clearTimeout(id));
    timerIdsRef.current = [];

    // Show the homepage immediately
    setCurrentPhase('travel-mhor');
    setShowHomePage(true);

    setTimeout(() => {
      if (onComplete) {
        onComplete();
      }
    }, 800);
  };

  useEffect(() => {
    if (skipAnimation) {
      // Skip to final state immediately
      setCurrentPhase('travel-mhor');
      setShowHomePage(true);
      if (onComplete) {
        onComplete();
      }
      return;
    }

    // Phase 1: Show "TRAVEL BIG" initially
    // (starts visible at 0ms)

    // Phase 2: Transition to "TRAVEL MORE" (at 2.5s)
    const timer1 = setTimeout(() => {
      setCurrentPhase('travel-more');
    }, ANIMATION_TIMINGS.phaseOne);

    // Phase 3: Transition from "TRAVEL MORE" to "TRAVEL MHOR" (at 5s total)
    const timer2 = setTimeout(() => {
      setCurrentPhase('travel-mhor');
    }, ANIMATION_TIMINGS.phaseTwo);

    // Phase 4: Show homepage (at 7s total)
    const timer3 = setTimeout(() => {
      setShowHomePage(true);
      if (onComplete) {
        onComplete();
      }
    }, ANIMATION_TIMINGS.phaseComplete);

    const ids = [timer1, timer2, timer3];
    timerIdsRef.current = ids;

    return () => {
      ids.forEach(id => clearTimeout(id));
    };
  }, [onComplete, skipAnimation]);

  return (
    <div
      className={`intro-animation ${showHomePage ? 'show-homepage' : ''} ${skipAnimation ? 'skip-animation' : ''}`}
      onClick={!showHomePage ? handleClick : undefined}
      style={{ cursor: !showHomePage ? 'pointer' : 'auto', pointerEvents: !showHomePage ? 'auto' : 'none' }}
    >
      <div
        className={`intro-background ${showHomePage ? 'fade-background' : ''}`}
        style={{ backgroundImage: 'url(/images/logos/logoTinified.png)' }}
      />
      <div className="intro-content">
        <img
          src={`${process.env.PUBLIC_URL}/images/intro/intro01.svg`}
          alt="Travel Big"
          className={`intro-animation-image intro-image-1 ${currentPhase === 'travel-big' ? 'visible' : 'hidden'}`}
        />
        <img
          src={`${process.env.PUBLIC_URL}/images/intro/intro02.svg`}
          alt="Travel More"
          className={`intro-animation-image intro-image-2 ${currentPhase === 'travel-more' ? 'visible' : 'hidden'}`}
        />
        <img
          src={`${process.env.PUBLIC_URL}/images/intro/intro03.svg`}
          alt="Travel Mhor"
          className={`intro-animation-image intro-image-3 ${currentPhase === 'travel-mhor' ? 'visible' : 'hidden'}`}
        />
      </div>
    </div>
  );
};

export default IntroAnimation;
